/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZoneRecord = {
    readonly id?: string;
    zone?: string | null;
    name: string;
    type: ZoneRecord.type;
    content: string;
    ttl: number;
};

export namespace ZoneRecord {

    export enum type {
        A = 'A',
        AAAA = 'AAAA',
        CNAME = 'CNAME',
        TXT = 'TXT',
        MX = 'MX',
        SRV = 'SRV',
        NS = 'NS',
        SPF = 'SPF',
        SSHFP = 'SSHFP',
        SOA = 'SOA',
        CAA = 'CAA',
    }


}

